import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
import { Configurations } from '../../Utils/Configurations';
import './Editions.scss';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import Session from '../../Utils/Session';
import update from 'immutability-helper';
import Usuario from './../../Utils/Usuario';
import Editions from '../../Components/Editions/Editions';
import qs from 'qs';
import Pagination from 'rc-pagination';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';



class EditionList extends Component {

    constructor(props) {
        super(props);

        this.defineNomePeriodico = this.defineNomePeriodico.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.handleInputEdicao = this.handleInputEdicao.bind(this);
        this.handleOnInput = this.handleOnInput.bind(this);
        this.resetModalInfos = this.resetModalInfos.bind(this);
        this.cadastraNovaEdicao = this.cadastraNovaEdicao.bind(this);
        this.selecionaEdicao = this.selecionaEdicao.bind(this);
        this.mudaStatusEdicao = this.mudaStatusEdicao.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.refreshTableEdition = this.refreshTableEdition.bind(this);
        this.edicaoDupla = this.edicaoDupla.bind(this);
        this.excluirEdicao = this.excluirEdicao.bind(this);
        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.carregaEdicoes = this.carregaEdicoes.bind(this);
        this.artigosSemEdicao = this.artigosSemEdicao.bind(this);
        this.destaquesPeriodico = this.destaquesPeriodico.bind(this);
        this.handleError = this.handleError.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            openModal: false,
            dtEdicao: null,
            numEdicao: '',
            edicaoDupla: false,
            isLoadingArtigos: false,
            isLoadingEdicoes: true,
            isLoadingStatusEdicao: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "publicar",
            naoCarregaEdicoes: false,
            listaEdicoes: [],
        }

    }

    componentDidMount() {
        this.carregaEdicoes();
    }

    excluirEdicao(_numEdicao) {
        alert(`Excluir edição ${_numEdicao}`)
    }

    mudaStatusEdicao() {
        const { numEdicaoStatusPublicacao, metodoStatusPublicacao } = this.state;

        this.toggleStatusPublicacao();
        this.setLoadingEdicao(numEdicaoStatusPublicacao, true);

        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${this.props.match.params.periodico}/${numEdicaoStatusPublicacao}/${metodoStatusPublicacao}`)
            .catch(err => { console.log(err); })
            .then(() => this.carregaEdicoes(false))
            .finally(() => this.setLoadingEdicao(numEdicaoStatusPublicacao, false));
    }

    setLoadingEdicao(_numEdicao, _loading) {
        this.setState(prevState => {
            const _index = prevState.listaEdicoes.findIndex(item => item.numeroEdicao === _numEdicao);
            if (_index === -1) return null;
            return { listaEdicoes: update(prevState.listaEdicoes, { [_index]: { loading: { $set: _loading } } }) };
        });
    }

    confirmaStatusPublicacao(_numEdicao, _metodo) {
        this.toggleStatusPublicacao();
        this.setState({
            numEdicaoStatusPublicacao: _numEdicao,
            metodoStatusPublicacao: _metodo
        })
    }

    componentWillMount() {
        let _permissoes;
        switch (this.props.match.params.periodico) {
            case "bs":
                _permissoes = [1, 4, 5, 14, 20];
                break;
            case "bj":
                _permissoes = [1, 4, 28, 14, 20];
                break;
            case "tc":
                _permissoes = [1, 4, 6, 14, 20];
                break;
            case "rd":
                _permissoes = [1, 4, 7, 14, 20];
                break;
            case "bm":
                _permissoes = [1, 4, 8, 14, 20];
                break;

            default:
                _permissoes = [1];
                break;
        }

        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const foundContent = roles.some(r => _permissoes.indexOf(r) >= 0);

        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!foundContent && !foundStatistic) this.props.history.push({ pathname: '/permissao-negada' })
        else {
            this.setState({ permissaoEdicao: foundContent })
            if (this.props.match.params.periodico === "bm") {
                this.props.history.push(`${this.props.match.url}/artigos`)
            }
            else {
                this.defineNomePeriodico();

            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.periodico !== prevProps.match.params.periodico) {
            Session.clearInfosEdicoes();
            this.defineNomePeriodico();
        }
    }

    componentWillUnmount() {
        if (!window.location.href.includes(`conteudo/${this.props.match.params.periodico}`)) Session.clearInfosEdicoes();
    }

    refreshTableEdition(o) {
        this.carregaEdicoes(o);
    }

    selecionaEdicao(_numEdicao) {
        this.props.history.push(`${this.props.match.url}/${_numEdicao}?pagina=1&limite=20`)
    }

    artigosSemEdicao() {
        this.props.history.push(`${this.props.match.url}/sem-edicao?pagina=1&limite=20`)
    }

    defineNomePeriodico() {
        let _nomePer, _idProd;
        switch (this.props.match.params.periodico.toLowerCase()) {
            case "bs": _nomePer = "Brasil Seikyo"; _idProd = 1; break;
            case "bj": _nomePer = "Brasil Seikyo Japonês"; _idProd = 2; break;
            case "tc": _nomePer = "Terceira Civilização"; _idProd = 3; break;
            case "rd": _nomePer = "Revista Dez"; _idProd = 4; break;
            default: _nomePer = ""; _idProd = 0; break;
        }
        this.setState(({ nomePeriodico: _nomePer, idProduto: _idProd }))
    }

    editarConteudo(_artigo) {
        this.props.history.push(`${this.props.match.url}/${_artigo.edicao}/${_artigo.idConteudo}`)
    }

    toggleModal() {
        this.setState({
            naoCarregaEdicoes: !this.state.openModal,
            openModal: !this.state.openModal,
        }, () => {
            if (!this.state.openModal) {
                this.carregaEdicoes();
                this.resetModalInfos();
            }
        })
    }

    resetModalInfos() { this.setState({ numEdicao: '', dtEdicao: null, edicaoDupla: false }) }


    onDateChange(date) { this.setState({ dtEdicao: date }) }

    _outsideRange(day) {
        // return day.format() > moment().format();
        return false
    }

    handleInputEdicao(e) {
        e.preventDefault();
        this.setState({ numEdicao: e.target.value })
    }

    handleOnInput(e) {
        if (e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4);
        }
    }

    cadastraNovaEdicao() {
        const _novaEdicao = {
            numero: this.state.numEdicao,
            dtPublicacao: this.state.dtEdicao,
            dupla: this.state.edicaoDupla,
        }
        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}`, _novaEdicao).then(response => { }).catch(err => {
            console.log(err);
        });
        this.toggleModal();
    }

    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    edicaoDupla() {
        this.setState({ edicaoDupla: !this.state.edicaoDupla });
    }

    carregaEdicoes(exibeLoadingLista = true) {
        if (exibeLoadingLista) this.setState({ isLoadingEdicoes: true })
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        return axios.get(this.Configurations.apiBasePath + `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}?pagina=${pagina}&limite=${limite}`)
            .then(response => {
                this.setState({
                    listaEdicoes: response.data.edicoes,
                    paginasEdicoes: response.data.paginacao.totalPaginas,
                    limite: limite,
                    pagina: pagina
                })
            })
            .catch(this.handleError)
            .finally(() => { this.setState({ isLoadingEdicoes: false }) })
    }

    onChangePage(page) {
        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/conteudo/${this.props.match.params.periodico.toLowerCase()}`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }

    destaquesPeriodico() {
        this.props.history.push(`/destaques/destaques-periodico/${this.props.match.params.periodico.toLowerCase()}`)
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        return (
            <div className="row edition-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-7 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Lista de Edições - {this.state.nomePeriodico} </h2>
                            <h5 className=" title-1 d-lg-none"> {this.props.match.params.periodico.toUpperCase()} - Lista de Edições</h5>
                        </div>
                        <div className="col-12 col-lg-2 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button className="btn btn-outline-info" type="button" name="semEdicao" onClick={this.artigosSemEdicao}>
                                        Artigos sem edição
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-3 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    {this.state.permissaoEdicao && (
                                        <button className="btn btn-outline-success" type="button" name="novaEdicao" onClick={this.toggleModal}>
                                            Cadastrar nova edição
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-12 px-0`}>
                        <div className="row no-gutters">
                            <div className={`col-12`}>
                                <div className="row no-gutters">
                                    {/* <div className={`col-12 text-center text-lg-left`}> */}
                                    <div className={`col-12 col-lg-9 text-center text-lg-left`}>
                                        <p className="py-2 m-0">Clique na edição para obter informações sobre os artigos.</p>
                                    </div>
                                    <div className={`col-3 text-right py-2 d-lg-block d-none`}>
                                        {this.state.permissaoEdicao && (
                                            <button className="btn btn-outline-info" type="button" name="destaquesPeriodico" onClick={this.destaquesPeriodico}>
                                                Destaques do periódico
                                            </button>
                                        )}
                                    </div>
                                    {this.state.isLoadingEdicoes ? (
                                        <div className="col-12 text-center px-3 py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <div className="col-12">
                                            <div className="row lista-edicoes">
                                                {this.state.listaEdicoes.map((item, index) => {
                                                    return (
                                                        <div className="col-12 py-2" key={index}>
                                                            <Editions
                                                                item={item}
                                                                confirmaStatusPublicacao={this.confirmaStatusPublicacao}
                                                                selecionaEdicao={this.selecionaEdicao}
                                                                permissaoEdicao={this.state.permissaoEdicao}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!this.state.isLoadingEdicoes && this.state.listaEdicoes && this.state.listaEdicoes.length > 0 && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-edicoes">
                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasEdicoes * this.state.limite} pageSize={this.state.limite} />
                            </div>
                        </div>
                    )}
                </div>

                <Modal className="modal-new-edition" isOpen={this.state.openModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <div className="row no-gutters">
                            <div className="col-12 d-none d-lg-block">
                                Cadastro de nova edição - {this.state.nomePeriodico}
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h5>Cadastro de nova edição</h5>
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h6>{this.state.nomePeriodico}</h6>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row no-gutters align-items-end">
                            <div className="col-6 col-lg-4 p-3">
                                <label>Número da edição</label>
                                <input autoComplete="off" name="titulo" className="form-control input-edicao" type="number" value={this.state.numEdicao.substr(0, 4)} onChange={this.handleInputEdicao} onInput={this.handleOnInput} />
                            </div>
                            <div className="col-6 col-lg-4 p-3">
                                <div className="row">
                                    <div className="col-12">
                                        <label>Data da edição</label>
                                    </div>
                                    <div className="col-12">
                                        <SingleDatePicker
                                            date={this.state.dtEdicao !== null ? moment(this.state.dtEdicao) : null} // momentPropTypes.momentObj or null
                                            onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                            focused={this.state.focused} // PropTypes.bool
                                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                            id="your_unique_id" // PropTypes.string.isRequired,
                                            orientation="horizontal"
                                            anchorDirection="right"
                                            openDirection="down"
                                            verticalHeight={450}
                                            numberOfMonths={1}
                                            small={true}
                                            phrases={this._phrases}
                                            placeholder=""
                                            isOutsideRange={this._outsideRange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 py-3 text-center order-2 order-lg-1">
                                <button onClick={this.cadastraNovaEdicao} disabled={this.state.numEdicao === '' || this.state.dtEdicao === null} className="btn btn-outline-success">cadastrar edição</button>
                            </div>
                            <div className="col-12 px-3 order-1 order-lg-2">
                                <input type="checkbox" className="check-box" onChange={this.edicaoDupla} checked={this.state.edicaoDupla} />
                                <label onClick={this.edicaoDupla} className="mx-2 pointer">Edição dupla</label>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status da Edição</ModalHeader>
                    <ModalBody>
                        {this.state.metodoStatusPublicacao === 'publicar' ? (
                            <p className="m-0">{`Deseja confirmar a publicação da Edição ${this.state.numEdicaoStatusPublicacao}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desativar a Edição ${this.state.numEdicaoStatusPublicacao}?`}</p>
                        )}

                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusEdicao ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusEdicao} color={`${this.state.metodoStatusPublicacao === 'publicar' ? `success` : `danger`}`} onClick={this.mudaStatusEdicao}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />

            </div>
        )
    }
}

export default EditionList;